'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function StarIcon(_ref) {
  var size = _ref.size,
      variant = _ref.variant;
  var starUrl = 'https://s3-us-west-1.amazonaws.com/housecall-icons-production/icons/images/';

  if (variant === 'empty') {
    starUrl += 'star_empty.png';
  } else if (variant === 'full') {
    starUrl += 'star_full.png';
  } else if (variant == 'half') {
    starUrl += 'star_half.png';
  } else if (variant == 'oneQuarter') {
    starUrl += 'star_one_quarter.png';
  } else if (variant == 'threeQuarters') {
    starUrl += 'star_three_quarters.png';
  }

  return React__default["default"].createElement("img", {
    src: starUrl,
    alt: variant,
    style: size ? {
      height: size
    } : {
      height: 40
    }
  });
}

module.exports = StarIcon;
